<template>
 <div>
  <v-dialog
      v-model="dialog"
      persistent
    >
      <v-card>
        <v-card-title class="headline">{{msg}}</v-card-title>
        <v-divider></v-divider>
        <v-card-actions>

          <v-btn
            color="green darken-1"
            text
            @click="agreeBtn"
          >
            同意
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="cancelBtn"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 </div>
</template>
<script>

export default {
  name: 'Confirm',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    }
  },
  // 定义的是默认数据, 默认值
  data() {
    return {
      agree: null, // 同意事件
      cancel: null // 取消事件
    };
  },
  methods: {
    /**
     * 取消按钮事件
     */
    cancelBtn: function() {
      if (this.cancel) {
        this.cancel()
      }
      this.$emit('cancel');
    },
    /**
     * 同意按钮事件
     */
    agreeBtn: function() {
      if (this.agree) {
        this.agree();
      }
      this.$emit('agree');
    }
  }
};
</script>
